import { render } from "./showSingleImage.vue?vue&type=template&id=545b6c8a&scoped=true"
import script from "./showSingleImage.vue?vue&type=script&lang=js"
export * from "./showSingleImage.vue?vue&type=script&lang=js"

import "./showSingleImage.vue?vue&type=style&index=0&id=545b6c8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545b6c8a"]])

export default __exports__